import * as _ from 'lodash';
import { Component, Input, Output } from '@angular/core';
import { finalize, first, takeUntil } from 'rxjs/operators';

import { ServiceItems, ServiceMembers, ServiceWorklabs, ServiceSecurity, ServiceTextAnalyser } from '@services';
import { Role, Member, Worklab } from '@models';
import { LinkedItemsComponent } from '../linked-items.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'participants',
    templateUrl: './participants.component.html',
    styleUrls: ['./participants.component.scss']
})
export class ParticipantsComponent extends LinkedItemsComponent {

    public canView = false;
    private _worklab: Worklab;
    @Input()
    set worklab(value: Worklab) {
        this._worklab = value;
        this.handleEditionMode(this._editionMode);
    }
    get worklab(): Worklab {
        return this._worklab;
    }

    constructor(
        private serviceItems: ServiceItems,
        private serviceMembers: ServiceMembers,
        private worklabsService: ServiceWorklabs,
        private serviceSecurity: ServiceSecurity,
        protected serviceTextAnalyser: ServiceTextAnalyser
    ) {
        super(serviceMembers, serviceTextAnalyser);
        this.field = 'participants';
        this.canView = this.serviceSecurity.hasMinimumRole(Role.ROLE_READER);
    }

    protected handleOrder(orderDirection: 'asc' | 'desc') {
        if (this._worklab instanceof Worklab) {
            this._worklab.participants = this.serviceMembers.sortArray(this._worklab.participants, orderDirection);
        }
    }

    protected handleEditionMode(value: boolean) {
        if (this._worklab instanceof Worklab) {
            this.isCreation = _.isUndefined(this._worklab.id);
            this.canEdit = this.worklabsService.userCanModifyParticipants(this._worklab);
            if (value === true && this.canEdit === true) {
                this.loadAllPotentialLinkedItems<Member>(this._worklab.participants, this._worklab);
            }
        }
    }

    addParticipant(member: Member) {
        member.isLoading = true;
        this.ctrl.reset();
        this.ctrl.disable();
        this.actionInProgress = true;

        let participants = this._worklab.participants;
        participants.push(member);
        participants = this.serviceMembers.sortArray(participants, 'asc');
        this._worklab.participants = participants;

        if (!this.isCreation) {
            this.worklabsService.startParticipating(this._worklab, member).pipe(
                finalize(() => {
                    this.ctrl.enable();
                    this.actionInProgress = false;
                    this.newLinkInput.nativeElement.focus();
                }),
                first(),
                takeUntil(this._destroyed$)
            ).subscribe(
                () => {
                    member.isLoading = false;
                    _.remove(this.allPotentialLinkedItems, function(o: Member) { return o.id === member.id; });

                    this._worklab.participants = participants;
                    if (this._worklab.witness) {
                        this._worklab.witness.participants = participants;
                    }
                    if (this.serviceSecurity.isCurrentUser(member)) {
                        this._worklab.isUserParticipant = true;
                        if (this._worklab.witness) {
                            this._worklab.witness.isUserParticipant = true;
                        }
                    }
                    this.serviceItems.item = this._worklab;
                },
                () => {
                    _.remove(this._worklab.participants, function(o: Member) { return o.id === member.id; });
                });
        } else {
            member.isLoading = false;
            _.remove(this.allPotentialLinkedItems, function(o: Member) { return o.id === member.id; });
            this.ctrl.enable();
            this.actionInProgress = false;
            this.newLinkInput.nativeElement.focus();
        }
    }

    removeParticipant(member: Member) {
        member.isLoading = true;
        this.ctrl.disable();
        this.actionInProgress = true;

        if (!this.isCreation) {
            this.worklabsService.stopParticipating(this._worklab, member).pipe(
                finalize(() => {
                    this.ctrl.enable();
                    this.actionInProgress = false;
                    member.isLoading = false;
                }),
                first(),
                takeUntil(this._destroyed$)
            ).subscribe(
                () => {
                    this.allPotentialLinkedItems.push(member);

                    const participants = this._worklab.participants;
                    _.remove(this._worklab.participants, function(o: Member) { return o.id === member.id; });

                    this._worklab.participants = participants;
                    if (this._worklab.witness) {
                        this._worklab.witness.participants = participants;
                    }
                    if (this.serviceSecurity.isCurrentUser(member)) {
                        this._worklab.isUserParticipant = true;
                        if (this._worklab.witness) {
                            this._worklab.witness.isUserParticipant = true;
                        }
                    }
                    this.serviceItems.item = this._worklab;
                },
                () => {
                    let participants = this._worklab.participants;
                    participants.push(member);
                    participants = this.serviceMembers.sortArray(participants, 'asc');

                    this._worklab.participants = participants;
                    if (this._worklab.witness) {
                        this._worklab.witness.participants = participants;
                    }
                    if (this.serviceSecurity.isCurrentUser(member)) {
                        this._worklab.isUserParticipant = false;
                        if (this._worklab.witness) {
                            this._worklab.witness.isUserParticipant = false;
                        }
                    }
                    this.serviceItems.item = this._worklab;
                }
            );
        } else {
            this.allPotentialLinkedItems.push(member);
            _.remove(this._worklab.participants, function(o: Member) { return o.id === member.id; });
            this.ctrl.enable();
            this.actionInProgress = false;
            member.isLoading = false;
        }
    }
}
